export default __webpack_public_path__ + "4eb152f4c0ef8dead61c6f80506c3e05.png";